import React from "react";
import { withTranslation } from "react-i18next";
import jsPDF from "jspdf";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import RefreshIcon from "@material-ui/icons/Refresh";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { RegistryConfirmationData } from "./RegistryConfirmationData";
import { calcularEdad } from "../../../../../services/utils";

class RegistryConfirmationPdfPreview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pdfPreviewUrl: null,
            loading: false,
            error: null,
        };
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.autoGenerate !== false) {
            this._autoGenerateTimeout = setTimeout(() => {
                this.generatePreview();
            }, this.props.delay || 300);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.refreshKey !== prevProps.refreshKey) {
            if (this._autoGenerateTimeout) clearTimeout(this._autoGenerateTimeout);
            this._autoGenerateTimeout = setTimeout(() => {
                this.generatePreview();
            }, this.props.delay || 300);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this._autoGenerateTimeout) clearTimeout(this._autoGenerateTimeout);
        this.clearPreviewUrl();
    }

    clearPreviewUrl = () => {
        if (this.state.pdfPreviewUrl) {
            URL.revokeObjectURL(this.state.pdfPreviewUrl);
        }
    };

    // generatePreview/downloadPdf son async (incluyen una espera activa por
    // el canvas del dorsal) — si el componente se desmonta antes de que
    // terminen, evita el warning/fuga de "setState en componente desmontado".
    safeSetState = (patch) => {
        if (this._isMounted) {
            this.setState(patch);
        }
    };

    detallePagoTarjetaFuncImpresoHTML = (jsonMail) => {
        return `
      <style>
        .fuente{
          font-size:11px;
          font-family:arial;
          margin-top:1px;
          padding-top:1px;
        }
        .title{
          font-size:13px;
          font-weight:bold;
        }
      </style>
      <div></div>
      <div class="fuente">
        De igual manera declaro que realice el pago de la inscripción via web con la tarjeta
        <b>${(jsonMail.datos.statusPago && jsonMail.datos.statusPago.brand) || ""}</b>
        registrada con el nombre de usuario
        <b>${(jsonMail.datos.statusPago && jsonMail.datos.statusPago.cardName) || ""}</b>
        cuyos últimos 4 digitos
        son <b>${(jsonMail.datos.statusPago && jsonMail.datos.statusPago.last4) || ""}</b>
        por un monto de
        <b>${(jsonMail.datos.statusPago && jsonMail.datos.statusPago.amount) || ""} MXN</b>
        a nombre de Dashport
      </div>

      <div class="fuente">
        Nota: La siguiente seccion debe ser llenada por el dueño de la tarjeta bancaria
        utilizada para realizar el pago.
      </div>

      <div class="title">
        Pagaré de tarjeta de Crédito / Débito negociable únicamente con instituciones de crédito.
      </div>

      <div class="fuente">
        Por este pagaré prometo y me obligo incondicionalemente a pagar a la orden de la
        institucion emisora de la tarjeta relacionada abajo, en sus oficinas, la cantidad de
        <b>${(jsonMail.datos.statusPago && jsonMail.datos.statusPago.amount) || ""} MXN</b>
        el cual suscribo al amparo del contrato que tengo celebrado con dicha institucion para el uso de esta tarjeta.
      </div>

      <div class="fuente">
        Reconozco y acepto que el presente es comprobante de la operacion señalada abajo, el
        cual tiene pleno valor probatorio y fuerza legal en virtud de que firme y/o digite mi
        firma electrónica, la cual es de mi exclusiva responsabilidad por lo que manifiesto
        plena conformidad respecto al cargo efectuado a la cuenta de la que se deriva esta
        tarjeta. El presente pagaré es negociable unicamente con instituciones bancarias a
        excepción que éste sea suscrito por tarjetahabientes de American Express.
      </div>

      <div class="fuente">
        Fecha y Hora de la transacción:
        <b>${(jsonMail.datos.statusPago && jsonMail.datos.statusPago.fechaPago) || ""}</b>
      </div>

      <div class="fuente">
        Importe:
        <b>${(jsonMail.datos.statusPago && jsonMail.datos.statusPago.amount) || ""} MXN</b>
      </div>

      <div class="fuente">Firma: __________________________________</div>

      <div class="fuente">Adicional a la identificación del atleta debe adjuntar:</div>
      <ul class="fuente">
        <li>1) Copia de la identificación oficial del dueño de la tarjeta por ambas caras.</li>
        <li>2) Copia de la tarjeta por su cara delantera tapando todos los digitos salvo los ultimos 4.</li>
        <li>3) Copia de la tarjeta por su cara trasera tapando los digitos del código de seguridad.</li>
      </ul>
    `;
    };

    // textoLegalPersonalizado: párrafo EXONERACIÓN guardado por el admin en
    // inscripcionesConfiguracion.deslindeResponsabilidades.textoMayores (ya
    // con {nombreEvento} sustituido). Si no viene, se usa el párrafo legal
    // por defecto de siempre, sin ningún cambio.
    deslindeResponsabilidadesMas18ImpresoHTML = (
        nombreEvento,
        linkAvisoPrivacidad,
        nombresYApellidos,
        numero,
        textoLegalPersonalizado,
        textoAvisoPersonalizado
    ) => {
        const parrafoAviso = textoAvisoPersonalizado
            ? `<div class="fuente">${textoAvisoPersonalizado}</div>`
            : `
      <div class="fuente">
        Es indispensable presentar este comprobante impreso y una copia de tu Credencial de Elector
        para poder recoger tu Kit de participante. El aviso de privacidad se puede consultar en
        <b>${linkAvisoPrivacidad || ""}</b>
      </div>`;

        const parrafoLegal = textoLegalPersonalizado
            ? `<div class="fuente">${textoLegalPersonalizado}</div>`
            : `
      <div class="fuente">
        EXONERACIÓN: Yo, participante inscrito al evento denominado
        <b>${nombreEvento || ""}</b>, por el sólo hecho de firmar este documento, acepto cualquier y todos
        los riesgos y peligros que sobre mi persona recaigan en cuanto a mi participación en el evento antes
        referido en adelante el "Evento". Por lo tanto, yo soy el único responsable de mi condición física,
        preparación, capacidad, mi salud, cualquier consecuencia, accidentes, perjuicios, deficiencias que
        puedan causar, de cualquier manera posible alteraciones a mi salud, integridad física, o inclusive
        la muerte, así como soy y seré responsable de los gastos totales que se generen por causa de algún
        accidente en competencia a mi persona. Por esa razón libero de cualquier responsabilidad al respecto
        a las instalaciones del lugar, los dueños del lugar donde se realiza la competencia, a las personas,
        clubes, grupos, a las Asociaciones que la integran y/o a la Empresa / Comité Organizador, sus
        directores, patrocinadores, accionistas, representantes, directores financieros y consejeros de las
        compañías, y por medio de este conducto renuncio, sin limitación alguna a cualquier derecho, demanda
        o indemnización al respecto. También reconozco y acepto que todas las personas y entidades referidas
        en el último párrafo no son ni serán consideradas responsables por la protección y custodia de mis
        pertenencias personales; además, no serán responsables por cualquier desperfecto, pérdida o robo
        relacionados con mis pertenencias personales. Autorizó al Comité organizador y/o a quien ésta designe
        el uso de mi imagen y voz, ya sea parcial o totalmente, en cuanto a todo lo relacionado en el Evento,
        de cualquier manera y en cualquier momento. Por este conducto reconozco que sé y entiendo todas las
        regulaciones del Evento, incluyendo y sin limitarse en lo general, así como en lo particular al
        reglamento interior de competencia. Igualmente, manifiesto bajo protesta de decir verdad que mi equipo
        de competencia reúne y cumple con todos los requisitos reglamentarios aplicables, sin perjuicio de la
        facultad que se tenga para revisar dicho equipo y los demás establecidos en la mencionada normatividad.
      </div>`;

        return `
      <style>
        .fuente{
          font-size:11px;
          font-family:arial;
          margin-top:1px;
          padding-top:1px;
        }
      </style>

      ${parrafoAviso}

      <div class="fuente">
        Al realizar mi inscripción en este evento declaro que me encuentro en plena capacidad física
        para participar en el mismo y deslindo de cualquier responsabilidad a las empresas organizadoras
        y patrocinadoras así como a sus representantes, de cualquier lesión o accidente como consecuencia
        de mi participación en el evento.
      </div>

      ${parrafoLegal}

      <div class="fuente">Tipo de ID ______________________ Número: <b>${numero || ""}</b></div>
      <div class="fuente">_______________________________________________________</div>
      <div class="fuente">Firma <b>${nombresYApellidos || ""}</b></div>
    `;
    };

    // textoLegalPersonalizado: párrafo CARTA RESPONSIVA guardado por el admin
    // en inscripcionesConfiguracion.deslindeResponsabilidades.textoMenores
    // (ya con {nombreEvento} sustituido). Si no viene, se usa el párrafo
    // legal por defecto de siempre, sin ningún cambio.
    deslindeResponsabilidadesMenos18ImpresoHTML = (
        nombreEvento,
        linkAvisoPrivacidad,
        nombresYApellidos,
        numero,
        textoLegalPersonalizado,
        textoAvisoPersonalizado
    ) => {
        const parrafoAviso = textoAvisoPersonalizado
            ? `<div class="fuente">${textoAvisoPersonalizado}</div>`
            : `
      <div class="fuente">
        Es indispensable presentar este comprobante impreso y una copia de tu Credencial de Elector
        para poder recoger tu Kit de participante. El aviso de privacidad se puede consultar en
        ${linkAvisoPrivacidad || ""}
      </div>`;

        const parrafoLegal = textoLegalPersonalizado
            ? `<div class="fuente">${textoLegalPersonalizado}</div>`
            : `
      <div class="fuente">
        CARTA RESPONSIVA PARA MENORES DE 18 AÑOS: Yo, el abajo firmante, como padre, madre o tutor del
        menor que estamos inscribiendo al evento <b>${nombreEvento || ""}</b>, declaro por esta misiva,
        por el sólo hecho de firmar este documento, acepto cualquier y todos los riesgos y peligros que
        sobre el/la niño/a recaigan en cuanto a su participación en el evento antes referido en adelante
        el "Evento". Por lo tanto, yo soy el único responsable de conocer su estado de salud, su condición
        física, preparación, capacidad, cualquier consecuencia, accidentes, perjuicios, deficiencias que
        puedan causar, de cualquier manera posible alteraciones a su salud, integridad física, o inclusive
        la muerte, así como soy y seré responsable los gastos totales que se generen por causa de algún
        accidente en competencia. Yo, el abajo firmante, seré siempre responsable de los accidentes que
        llegara a sufrir el niño o niña competidor inscrito, ya que declaro que estoy en pleno conocimiento
        de los riesgos y peligros inherentes en las áreas del evento o participando en este, por lo que por
        esa razón libero de cualquier responsabilidad al respecto a las instalaciones del lugar, los dueños
        del lugar donde se realiza la competencia, a las personas, clubes, grupos, a las Asociaciones que
        la integran y/o a la Empresa / Comité Organizador, sus directores, patrocinadores, accionistas,
        representantes, directores financieros y consejeros de las compañías, y por medio de este conducto
        renuncio, sin limitación alguna a cualquier derecho, demanda o indemnización al respecto. Además,
        no serán responsables por cualquier desperfecto, pérdida o robo relacionados con las pertenencias
        personales del niño o niña. Así mismo, autorizó al Comité organizador y/o a quien ésta designe el
        uso de la imagen y voz del niño/a, ya sea parcial o totalmente, en cuanto a todo lo relacionado en
        el Evento, de cualquier manera y en cualquier momento. Por este conducto reconozco que sé y entiendo
        todas las regulaciones del Evento, incluyendo y sin limitarse en lo general, así como en lo particular
        al reglamento interior de competencia. Igualmente, manifiesto bajo protesta de decir verdad que el equipo
        de competencia reúne y cumple con todos los requisitos reglamentarios aplicables, sin perjuicio de la
        facultad que se tenga para revisar dicho equipo y los demás establecidos en la mencionada normatividad.
      </div>`;

        return `
      <style>
        .fuente{
          font-size:11px;
          font-family:arial;
          margin-top:1px;
          padding-top:1px;
        }
        .center{
          text-align:center;
        }
      </style>

      ${parrafoAviso}

      <div class="fuente">
        Al realizar mi inscripción en este evento declaro que me encuentro en plena capacidad física
        para participar en el mismo y deslindo de cualquier responsabilidad a las empresas organizadoras
        y patrocinadoras así como a sus representantes, de cualquier lesión o accidente como consecuencia
        de mi participación en el evento.
      </div>

      ${parrafoLegal}

      <div class="fuente">Tipo de ID ______________________ Número: <b>${numero || ""}</b></div>
      <div class="fuente">Atleta representado: <b>${nombresYApellidos || ""}</b></div>
      <div class="fuente">_________________________________________________________</div>
      <div class="fuente">Nombre Completo del Padre o Tutor (escrito a mano)</div>
      <div class="fuente">_________________________________________________________</div>
      <div class="fuente">Firma</div>
      <div class="fuente">
        EN TESTIMONIO DE FE, COMO RESPONSABLES DEL COMPETIDOR INSCRITO, NOSOTROS COMO PADRES O TUTORES,
        DECLARAMOS HABER ENTENDIDO LO ANTERIORMENTE DESCRITO Y AÑADIMOS LA FIRMA EN FORMA VOLUNTARIA.
      </div>
    `;
    };


    getDorsalDataUrl = () => {
        const { dorsalElementId = "dorsalPreviewCanvas" } = this.props;

        const dorsalContainer = document.getElementById(dorsalElementId);
        if (!dorsalContainer) return null;

        const canvas = dorsalContainer.querySelector("canvas");
        if (canvas) {
            return canvas.toDataURL("image/jpg", 0.95);
        }

        const img = dorsalContainer.querySelector("img");
        if (img && img.src) {
            return img.src;
        }

        return null;
    };
    pdfTexto = (doc, left, top, titulo, texto, fontSize = 12) => {
        doc.setFont("times");
        doc.setFontType("normal");
        doc.setFontSize(8);
        doc.text(left, top, (titulo || "").toString());

        doc.setFont("times");
        doc.setFontType("normal");
        doc.setFontSize(fontSize);

        var text = doc
            .setFont("times")
            .setFontSize(fontSize)
            .setFontType("normal")
            .splitTextToSize((texto || "").toString(), 80);

        doc.text(left, top + 5, text);
    };

    waitForDorsal = async (maxAttempts = 10, interval = 300) => {
        const { dorsalElementId = "dorsalPreviewCanvas" } = this.props;

        for (let attempt = 0; attempt < maxAttempts; attempt++) {
            const dorsalContainer = document.getElementById(dorsalElementId);

            if (dorsalContainer) {
                const canvas = dorsalContainer.querySelector("canvas");
                const img = dorsalContainer.querySelector("img");

                if (canvas) return true;
                if (img && img.src) return true;
            }

            await new Promise((resolve) => setTimeout(resolve, interval));
        }

        return false;
    };
    buildPDF = () => {
        const { jsonMail, qrElementId = "qrSeguimiento" } = this.props;

        if (!jsonMail || !jsonMail.datos || !jsonMail.detalleEvento) {
            throw new Error("No se recibió jsonMail completo para generar el PDF");
        }

        var numero = 0;
        if (jsonMail.datos.numero != undefined) {
            numero = jsonMail.datos.numero;
        }

        var distancia = "";
        var modIndex = "modalidad_" + jsonMail.datos.modalidad;
        if (
            jsonMail.datos.modalidad != undefined &&
            jsonMail.modalidades &&
            jsonMail.modalidades[modIndex]
        ) {
            distancia = jsonMail.modalidades[modIndex].descripcionModalidad;
        }

        var rama = "";
        var ramaIndex;
        if (jsonMail.datos.rama != undefined) {
            ramaIndex = "rama_" + jsonMail.datos.rama;
            rama = jsonMail.datos.rama;
        }

        var categoria = "";
        if (
            jsonMail.datos.categoria != undefined &&
            jsonMail.modalidades &&
            jsonMail.modalidades[modIndex] &&
            jsonMail.modalidades[modIndex].ramaCat &&
            jsonMail.modalidades[modIndex].ramaCat[ramaIndex] &&
            jsonMail.modalidades[modIndex].ramaCat[ramaIndex].categorias
        ) {
            var categoriaIndex = "categoria_" + jsonMail.datos.categoria;
            var categoriaJson =
                jsonMail.modalidades[modIndex].ramaCat[ramaIndex].categorias[categoriaIndex];
            categoria = categoriaJson ? categoriaJson.nombreCategoria : "";
        }

        var idioma = "es";
        var jsonTextos = RegistryConfirmationData;

        var edad = calcularEdad(
            jsonMail.datos.fechaNacimiento,
            jsonMail.detalleEvento.fechaEvento,
            true
        );

        // Texto legal personalizado por el admin (inscripcionesConfiguracion
        // ya llega en jsonMail, sin lectura adicional a Firebase). Si el
        // evento no tiene override guardado, queda undefined y las funciones
        // de abajo usan el párrafo por defecto de siempre.
        const deslindeConfig =
            (jsonMail.inscripcionesConfiguracion &&
                jsonMail.inscripcionesConfiguracion.deslindeResponsabilidades) ||
            {};
        const nombreEventoParaDeslinde = jsonMail.detalleEvento.nombreEvento || "";
        const linkAvisoPrivacidadParaDeslinde =
            (jsonMail.detalleEvento.organizador &&
                jsonMail.detalleEvento.organizador.linkAvisoPrivacidad) ||
            "";
        const textoPersonalizadoCrudo =
            edad < 18 ? deslindeConfig.textoMenores : deslindeConfig.textoMayores;
        // Las variables sustituidas quedan en negritas (<b>), igual que en
        // el texto por defecto de arriba (${nombreEvento} ya viene envuelto
        // en <b> ahí).
        const textoLegalPersonalizado = textoPersonalizadoCrudo
            ? textoPersonalizadoCrudo
                .split("{nombreEvento}")
                .join(`<b>${nombreEventoParaDeslinde}</b>`)
            : undefined;
        const textoAvisoPersonalizado = deslindeConfig.textoAviso
            ? deslindeConfig.textoAviso
                .split("{nombreEvento}")
                .join(`<b>${nombreEventoParaDeslinde}</b>`)
                .split("{linkAvisoPrivacidad}")
                .join(`<b>${linkAvisoPrivacidadParaDeslinde}</b>`)
            : undefined;

        var doc = new jsPDF("p", "mm", "letter");
        var margin = 20;
        var extraMargin = 1.4;

        const qrCodeCanvas = document.getElementById(qrElementId);
        if (qrCodeCanvas) {
            const qrCodeDataUri = qrCodeCanvas.toDataURL("image/jpg", 0.3);

            if (
                jsonMail.inscripcionesConfiguracion &&
                jsonMail.inscripcionesConfiguracion.configuracion &&
                jsonMail.inscripcionesConfiguracion.configuracion.dorsal
            ) {
                doc.addImage(qrCodeDataUri, "jpg", 160, 25, 40, 40);

                const dorsalDataUrl = this.getDorsalDataUrl();
                if (dorsalDataUrl) {
                    doc.addImage(dorsalDataUrl, "jpg", 115, 29, 40, 32);
                }
            } else {
                doc.addImage(qrCodeDataUri, "jpg", 140, 25, 40, 40);
                this.pdfTexto(doc, 140, 15, "", "# " + numero, 40);
            }
        }

        this.pdfTexto(
            doc,
            margin * extraMargin,
            25,
            "Nombres y Apellidos",
            (jsonMail.datos.nombres || "") + " " + (jsonMail.datos.apellidos || "")
        );
        this.pdfTexto(
            doc,
            margin * 2 * extraMargin,
            35,
            "",
            jsonTextos[idioma].tituloDatos
        );
        this.pdfTexto(doc, margin * extraMargin, 45, jsonTextos[idioma].Numero, numero, 12);
        this.pdfTexto(
            doc,
            margin * 2.5 * extraMargin,
            45,
            jsonTextos[idioma].Distancia,
            distancia
        );
        this.pdfTexto(doc, margin * extraMargin, 60, jsonTextos[idioma].Rama, rama);
        this.pdfTexto(
            doc,
            margin * 2.5 * extraMargin,
            60,
            jsonTextos[idioma].Categoria,
            categoria
        );

        let deslindeFinalHTML = "";

        if (edad < 18) {
            deslindeFinalHTML = this.deslindeResponsabilidadesMenos18ImpresoHTML(
                jsonMail.detalleEvento.nombreEvento || "",
                (jsonMail.detalleEvento.organizador &&
                    jsonMail.detalleEvento.organizador.linkAvisoPrivacidad) ||
                "",
                (jsonMail.datos.nombres || "") + " " + (jsonMail.datos.apellidos || ""),
                numero,
                textoLegalPersonalizado,
                textoAvisoPersonalizado
            );
        } else {
            deslindeFinalHTML = this.deslindeResponsabilidadesMas18ImpresoHTML(
                jsonMail.detalleEvento.nombreEvento || "",
                (jsonMail.detalleEvento.organizador &&
                    jsonMail.detalleEvento.organizador.linkAvisoPrivacidad) ||
                "",
                (jsonMail.datos.nombres || "") + " " + (jsonMail.datos.apellidos || ""),
                numero,
                textoLegalPersonalizado,
                textoAvisoPersonalizado
            );
        }

        doc.fromHTML(deslindeFinalHTML, 20, 70, { width: 180 });

        if (jsonMail.datos.statusPago && jsonMail.datos.statusPago.last4 != undefined && edad >= 18) {
            const detallePagoTarjetaHTML = this.detallePagoTarjetaFuncImpresoHTML(jsonMail);
            //doc.fromHTML(detallePagoTarjetaHTML, 20, 170, { width: 180 });
        }

        if (jsonMail.detalleEvento.iDEvento === 1142 && jsonMail.datos.modalidad === 2) {
            const atributes = {
                2: {
                    nombre: "nombredel2docompetidor",
                    apellido: "apellidosdel2docompetidor",
                    genero: "generodel2docompetidor",
                },
                3: {
                    nombre: "nombredel3ercompetidor",
                    apellido: "apellidosdel3ercompetidor",
                    genero: "generodel3ercompetidor",
                },
                4: {
                    nombre: "nombredel4tocompetidor",
                    apellido: "apellidosdel4tocompetidor",
                    genero: "generodel4tocompetidor",
                },
                5: {
                    nombre: "nombredel5tocompetidor",
                    apellido: "apellidosdel5tocompetidor",
                    genero: "generodel5tocompetidor",
                },
            };

            for (var i = 2; i <= 5; i++) {
                doc.addPage();

                const qrCodeCanvasExtra = document.getElementById(qrElementId);
                if (qrCodeCanvasExtra) {
                    const qrCodeDataUriExtra = qrCodeCanvasExtra.toDataURL("image/jpg", 0.3);

                    if (
                        jsonMail.inscripcionesConfiguracion &&
                        jsonMail.inscripcionesConfiguracion.configuracion &&
                        jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                    ) {
                        doc.addImage(qrCodeDataUriExtra, "jpg", 160, 25, 40, 40);
                        const dorsalDataUrl = this.getDorsalDataUrl();
                        if (dorsalDataUrl) {
                            doc.addImage(dorsalDataUrl, "jpg", 115, 29, 40, 32);
                        }
                    } else {
                        doc.addImage(qrCodeDataUriExtra, "jpg", 140, 25, 40, 40);
                        this.pdfTexto(doc, 140, 15, "", "# " + numero, 40);
                    }
                }

                const nombreCompetidor =
                    ((jsonMail.datos[atributes[i].nombre] || "") + " " + (jsonMail.datos[atributes[i].apellido] || "")).trim();

                this.pdfTexto(doc, margin * extraMargin, 25, "Nombres y Apellidos", nombreCompetidor);
                this.pdfTexto(
                    doc,
                    margin * 2 * extraMargin,
                    35,
                    "",
                    jsonTextos[idioma].tituloDatos
                );
                this.pdfTexto(doc, margin * extraMargin, 45, jsonTextos[idioma].Numero, numero, 12);
                this.pdfTexto(
                    doc,
                    margin * 2.5 * extraMargin,
                    45,
                    jsonTextos[idioma].Distancia,
                    distancia
                );
                this.pdfTexto(
                    doc,
                    margin * extraMargin,
                    60,
                    jsonTextos[idioma].Rama,
                    jsonMail.datos[atributes[i].genero] || ""
                );
                this.pdfTexto(
                    doc,
                    margin * 2.5 * extraMargin,
                    60,
                    jsonTextos[idioma].Categoria,
                    categoria
                );

                let deslindeParticipanteExtra = "";

                if (edad < 18) {
                    deslindeParticipanteExtra = this.deslindeResponsabilidadesMenos18ImpresoHTML(
                        jsonMail.detalleEvento.nombreEvento || "",
                        (jsonMail.detalleEvento.organizador &&
                            jsonMail.detalleEvento.organizador.linkAvisoPrivacidad) ||
                        "",
                        nombreCompetidor,
                        numero,
                        textoLegalPersonalizado,
                        textoAvisoPersonalizado
                    );
                } else {
                    deslindeParticipanteExtra = this.deslindeResponsabilidadesMas18ImpresoHTML(
                        jsonMail.detalleEvento.nombreEvento || "",
                        (jsonMail.detalleEvento.organizador &&
                            jsonMail.detalleEvento.organizador.linkAvisoPrivacidad) ||
                        "",
                        nombreCompetidor,
                        numero,
                        textoLegalPersonalizado,
                        textoAvisoPersonalizado
                    );
                }

                doc.fromHTML(deslindeParticipanteExtra, 20, 70, { width: 180 });
            }
        }

        return doc;
    };

    generatePreview = async () => {
        try {
            this.safeSetState({ loading: true, error: null });

            await this.waitForDorsal(
                this.props.dorsalMaxAttempts || 10,
                this.props.dorsalRetryInterval || 300
            );

            if (!this._isMounted) return;

            const doc = this.buildPDF();
            const pdfBlob = doc.output("blob");
            const pdfPreviewUrl = URL.createObjectURL(pdfBlob);

            if (!this._isMounted) {
                URL.revokeObjectURL(pdfPreviewUrl);
                return;
            }

            this.clearPreviewUrl();

            this.safeSetState({
                pdfPreviewUrl,
                loading: false,
            });
        } catch (error) {
            console.log(error);
            this.safeSetState({
                loading: false,
                error: error.message || this.props.t("confirmacion.errorAlGenerarPdf"),
            });
        }
    };
    downloadPdf = async () => {
        try {
            this.safeSetState({ loading: true, error: null });

            const { jsonMail } = this.props;
            const doc = this.buildPDF();

            const fileName =
                this.props.fileName ||
                `Deslinde de responsabildiades - ${(jsonMail.detalleEvento && jsonMail.detalleEvento.nombreEvento) || "evento"} - ${(jsonMail.datos && jsonMail.datos.nombres) || ""} ${(jsonMail.datos && jsonMail.datos.apellidos) || ""}.pdf`;

            doc.save(fileName);

            this.safeSetState({ loading: false });
        } catch (error) {
            console.log(error);
            this.safeSetState({
                loading: false,
                error: error.message || this.props.t("confirmacion.errorAlDescargarPdf"),
            });
        }
    };

    render() {
        const {
            title,
            height = 500,
            maxWidth = 900,
            showDownloadButton = true,
            showRefreshButton = true,
            containerStyle = {},
            t,
        } = this.props;

        const { pdfPreviewUrl, loading, error } = this.state;

        return (
            <div
                style={{
                    width: "100%",
                    maxWidth: maxWidth,
                    margin: "0 auto",
                    ...containerStyle,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                        marginBottom: 16,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <PictureAsPdfIcon color="secondary" />
                        <Typography variant="h5" color="primary">
                            {title || t("confirmacion.vistaPreviaPdf")}
                        </Typography>
                    </div>

                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                        {showRefreshButton && (
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={this.generatePreview}
                                disabled={loading}
                                startIcon={<RefreshIcon />}
                            >
                                {t("confirmacion.actualizarVistaPrevia")}
                            </Button>
                        )}

                        {showDownloadButton && (
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.downloadPdf}
                                disabled={loading}
                                startIcon={<GetAppIcon />}
                            >
                                {t("confirmacion.descargarPdf")}
                            </Button>
                        )}
                    </div>
                </div>

                <div
                    style={{
                        width: "100%",
                        minHeight: height,
                        border: "1px solid #dcdcdc",
                        borderRadius: 10,
                        overflow: "hidden",
                        backgroundColor: "#fafafa",
                    }}
                >
                    {loading && (
                        <div
                            style={{
                                minHeight: height,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 12,
                                padding: 20,
                            }}
                        >
                            <CircularProgress color="secondary" />
                            <Typography variant="body1" color="textSecondary">
                                {t("confirmacion.generandoPdf")}
                            </Typography>
                        </div>
                    )}

                    {!loading && error && (
                        <div
                            style={{
                                minHeight: height,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: 24,
                                textAlign: "center",
                            }}
                        >
                            <div>
                                <Typography variant="h6" color="error" gutterBottom>
                                    {t("confirmacion.noSePudoGenerarVistaPrevia")}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {error}
                                </Typography>
                            </div>
                        </div>
                    )}

                    {!loading && !error && pdfPreviewUrl && (
                        <iframe
                            title="Vista previa PDF"
                            src={pdfPreviewUrl}
                            style={{
                                width: "100%",
                                height: height,
                                border: "none",
                                display: "block",
                            }}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default withTranslation("inscripcion")(RegistryConfirmationPdfPreview);